import {
  Box,
  Button,
  Grid,
  IconButton,
  styled,
  Typography,
} from '@mui/material';

export const ProductLineContainer = styled(Box)(
  ({ theme }) => `
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem;
    border-bottom: 0.0625rem solid ${theme.palette.brand.disable};
`,
);

export const ProductLineId = styled(Typography)(
  () => `
    font-weight: 400;
    flex: 0.1;
    margin-right: 10px;
`,
);

export const ProductLineName = styled(Button)(
  ({ theme, $width }) => `
    flex: 1;
    padding: 0;
    justify-content: flex-start;
    display: block;
    min-height: 30px;
    min-width: ${$width ? `${$width}px` : '100px'} ;

    & p {
      margin: 0;
      font-weight: 300;
      font-size: 1rem;
      color: ${theme.palette.primary.main};
      padding: 0;
      text-align: left;
    }
`,
);

export const ProductLineIcon = styled(IconButton)`
  padding: 0;
`;

export const IconContainer = styled(Box)`
  display: inline-flex;
  > * {
    margin: 0 0 0 5px;
    padding: 2px;
  }
`;

export const SortableKnobIcon = styled(Box)`
  display: inline-block;
  cursor: grab;
  padding-bottom: 0px;
  margin-right: 10px;
`;

export const FlexGrid = styled(Grid)`
  display: flex;
  align-items: center;
`;
